import { useMemo } from 'react'
import { useOutletContext } from 'react-router-dom'

import { DashboardListPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import DashboardList from 'modules/reports/components/DashboardList'
import type { DashboardAuthorInfo } from 'modules/reports/lib/types'
import type { RouteContextParams } from 'modules/reports/lib/RouterContextParams'

const DashboardListPage = () => {
  const { loading: loadingContext } = useOutletContext<RouteContextParams>()

  const { data, loading: loadingQuery } = useQuery(DashboardListPageDocument)

  const loading = loadingContext || loadingQuery

  const canManageReports = data?.reports._policies.useReports.can ?? false

  const authorsByDashboardId = useMemo(() => {
    const map = new Map<string, DashboardAuthorInfo>()
    if (data) {
      for (const dashboard of data.reports.dashboards) {
        if (dashboard.id && dashboard.author) {
          map.set(dashboard.id, {
            id: dashboard.author.id,
            firstName: dashboard.author.firstName,
            lastName: dashboard.author.lastName,
            avatar: dashboard.author.avatar,
          })
        }
      }
    }
    return map
  }, [data])

  return (
    <DashboardList
      loading={loading}
      canManageReports={canManageReports}
      authorsByDashboardId={authorsByDashboardId}
    />
  )
}

export default DashboardListPage
